import { createSwitchlessReducer } from '../../util/switchlessReducer';
import namespace from './namespace';
import type { Dispatch } from 'redux';
import fulfill from '../../fulfill';
import { CORE_API_HOSTNAME } from '../../env';
import { Transaction } from '../../types/checkout';
import { UiState, Error } from './types';
import { download } from '../../helpers/download/download';
import { createAccountIdChangedCaseReducer } from '../../auth/useAccountId';

export interface State {
    transaction: Transaction | undefined;
    state: UiState;
    error: Error | undefined;
}

export const initialState: State = {
    state: UiState.Inactive,
    transaction: undefined,
    error: undefined,
};

export const { reducer, actions } = createSwitchlessReducer({
    namespace: namespace,
    initialState,
    reducers: {
        dismiss: (state: State) => {
            return initialState;
        },
        error: (state: State, error: Error): State => {
            return {
                ...state,
                state: UiState.Error,
                error,
            };
        },
    },
    globalReducer: createAccountIdChangedCaseReducer(() => initialState),
});


type ReportRequestData = {
    key: string;
    path: string;
    data: Transaction;
}

interface HttpError {
    error: {
        message: string;
        code: string;
        errors: any;
    };
}

export const createReportTransactionActions = (dispatch: Dispatch) => {
    const generateReport = async (account_id: string, transaction: Transaction, language: string) => {
        const reportURL = new URL(`${CORE_API_HOSTNAME}/v1/accounts/${account_id}/reports/generation`);
        const params = reportURL.searchParams;
        params.append('template_id', 'checkout_transaction_order');
        params.append('template_data_path', `/checkout/v1/transactions/${transaction.id}`);
        params.append('template_accept', 'application/pdf');
        params.append('template_accept_language', language || 'en');

        await fulfill.post<ReportRequestData[]>({
            accountId: account_id,
            url: reportURL.toString(),
            json: [
                {
                    key: 'transaction',
                    path: `/checkout/v1/transactions/${transaction.id}`,
                    data: transaction,
                },
            ],
            handlers: {
                200: (blob: Blob, headers) => {
                    download(`${transaction.id}.pdf`, blob);
                },
                400: (response: HttpError) => {
                    dispatch(actions.error(response.error));
                },
            },
        });
    };

    const dismissReportModal = () => {
        dispatch(actions.dismiss());
    };

    return {
        generateReport,
        dismissReportModal,
    };
};
